// extracted by mini-css-extract-plugin
module.exports = {"bg_l5":"#8f8f8f","monoStack":"\"Roboto Mono\",monospace","hint":"Hint_hint__2N6pm","hintInner":"Hint_hintInner__37_IA"};